// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.6162 3.26835L11.9994 0.186157L8.38263 3.26835L3.64575 3.64636L3.26774 8.38324L0.185547 12L3.26774 15.6168L3.64575 20.3537L8.38264 20.7317L11.9994 23.8139L15.6162 20.7317L20.3531 20.3537L20.7311 15.6168L23.8133 12L20.7311 8.38325L20.3531 3.64636L15.6162 3.26835ZM10.9994 16.4142L6.58521 12L7.99942 10.5858L10.9994 13.5858L16.4994 8.08582L17.9136 9.50003L10.9994 16.4142Z"}}]};

const VerifiedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'verified-filled',
    ref,
    icon: element,
  },
));

VerifiedFilledIcon.displayName = 'VerifiedFilledIcon';

export default VerifiedFilledIcon;
